import script from "./FieldImporterMapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldImporterMapper.vue?vue&type=script&setup=true&lang=ts"

import "./FieldImporterMapper.vue?vue&type=style&index=0&id=05a4d358&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a4d358"]])

export default __exports__